
const getDefaultFilter = () => ({
})

export default {
  namespaced: true,
  state: {
    filter: getDefaultFilter(),
    results: { total: -1, list: [] }
  },
  mutations: {
    setResults (state, results) {
      state.results = results
    }
  }
}
